import { Injectable }             from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot }    from '@angular/router';
import { AuthService }            from './auth.service';
import { Role } from 'app/shared/models/role';

@Injectable()
export class AuthGuard implements CanActivate {
    constructor(private authService: AuthService, private router: Router) {}

      canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        return this.authService.getCurrentUser()
        .then(user => {
            if (user && user.role === Role.Client) {
                return true;
            }
            else {
              this.router.navigate(['/login'], {
                  queryParams: {
                      return: state.url
                  }
              });
              return false;
            }
        }).catch (error => {
            this.router.navigate(['/login'], {
              queryParams: {
                  return: state.url
              }
          });

          return false;
        });
      }

    canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
        return this.canActivate(route, state);
    }

}



// WEBPACK FOOTER //
// ./src/app/login/services/auth-guard.service.ts